import React from 'react';
import { useTranslation } from 'react-i18next';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import CenteredQButton from '../Shared/CenteredQButton';
import FlexContainer from '../Shared/FlexContainers/FlexContainer';
import HeaderWithDescription from '../Shared/HeaderWithDescription';

const Instructions = (): JSX.Element => {
  const namespace = TranslationNamespaces.twoFA;
  const { t } = useTranslation(namespace);

  return (
    <>
      <HeaderWithDescription description='descriptionInstructions' translationNamespace={namespace} />
      <FlexContainer>
        <CenteredQButton to='/Enable2FA/LinkAuthenticator' color='secondary' fullWidth>
          {t('next')}
        </CenteredQButton>

        <CenteredQButton to='/' variant='text'>
          {t('cancel')}
        </CenteredQButton>
      </FlexContainer>
    </>
  );
};

export default Instructions;
